import { useState } from 'react'

import { type TextareaSubmitPayload, TextareaWithSubmit } from '@/components/composer/TextareaWithSubmit'
import type { ChatAttachment, ChatContent, ChatContentNested } from '../../models/chat'
import { ChatActionWithValue } from '../../models/insuranceApplication'

interface ChatComposerProps {
  content: ChatContentNested
  service: string
  handleSubmit: (data: ChatActionWithValue | FormData) => void
  addonChildren?: React.ReactNode
  readonly?: boolean
  enableUploads?: boolean
  /** Pinned under the chat rather than inline in it. */
  pill?: boolean
}

export function ChatComposer({
  content,
  handleSubmit,
  service,
  ref,
  addonChildren,
  readonly,
  enableUploads,
  pill,
}: ChatComposerProps & React.RefAttributes<HTMLTextAreaElement>) {
  const initialValue =
    typeof content === 'object' && content !== null && !Array.isArray(content)
      ? ((content as ChatContent).props?.defaultValue as string | undefined) || ''
      : ''
  const [value, setValue] = useState(initialValue)

  function onSubmitMessage(payload: TextareaSubmitPayload) {
    const chatAttachments: ChatAttachment[] = payload.attachments.map((a) => ({
      documentId: a.documentId,
      attachmentId: a.attachmentId,
      fileName: a.fileName,
      fileExtension: a.fileExtension,
      fileSize: a.fileSize,
      fileUrl: a.fileUrl,
    }))
    handleSubmit({
      content: {
        component: 'P',
        content: payload.message,
        ...(chatAttachments.length > 0 ? { attachments: chatAttachments } : {}),
      },
      value: payload.message,
      service,
      documentIds: payload.documentIds,
    } as ChatActionWithValue)
    setValue('')
  }

  return (
    <div className={pill ? 'w-full' : 'mt-6 w-full'}>
      <TextareaWithSubmit
        {...(typeof content === 'object' && !Array.isArray(content) ? (content as ChatContent).props : {})}
        value={value}
        onValueChange={setValue}
        onSubmitMessage={onSubmitMessage}
        buttonProps={{ disabled: readonly }}
        ref={ref}
        addonChildren={addonChildren}
        disabled={readonly}
        enableUploads={enableUploads}
        pill={pill}
      />
    </div>
  )
}
